import { oc } from "@orpc/contract";
import { z } from "zod";
import { SystemEntity } from "@erp/shared-types";

const UUIDSchema = z.uuid();

export const ActivityItemTypeSchema = z.enum([
  "created",
  "update",
  "status_change",
  "email",
  "linked",
  "ai_action",
  "other",
]);

export const ActivityItemActorSchema = z.object({
  id: UUIDSchema,
  name: z.string(),
  email: z.string().optional(),
});

export const ActivityItemSchema = z.object({
  id: z.string(),
  type: ActivityItemTypeSchema,
  timestamp: z.coerce.date(),
  actor: ActivityItemActorSchema.optional(),
  metadata: z.record(z.string(), z.unknown()),
});

export const ListActivityLogInputSchema = z.object({
  entityType: z.enum(SystemEntity),
  entityId: UUIDSchema,
  limit: z.number().int().min(1).max(100).optional().default(50),
  offset: z.number().int().min(0).optional().default(0),
});

export const ListActivityLogResponseSchema = z.object({
  items: z.array(ActivityItemSchema),
});

export const activityLogContracts = {
  list: oc
    .input(ListActivityLogInputSchema)
    .output(ListActivityLogResponseSchema)
    .route({
      method: "GET",
    }),
} as const;

export type ActivityItemType = z.infer<typeof ActivityItemTypeSchema>;
export type ActivityItemActor = z.infer<typeof ActivityItemActorSchema>;
export type ActivityItem = z.infer<typeof ActivityItemSchema>;
export type ListActivityLogInput = z.infer<typeof ListActivityLogInputSchema>;
export type ListActivityLogResponse = z.infer<
  typeof ListActivityLogResponseSchema
>;
